import { supabase } from "@/lib/supabase";

export type Classroom = {
  id: string;
  name: string;
  code: string;
  teacher_id: string;
  teacher_name: string | null;
  is_teacher: boolean;
};

async function requireUser() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  if (!user) throw new Error("É necessário entrar na conta.");
  return user;
}

export async function loadMyClassrooms(): Promise<Classroom[]> {
  await requireUser();
  const { data, error } = await supabase.rpc("my_classrooms");
  if (error) throw new Error("Não foi possível carregar suas turmas.");
  return (data ?? []) as Classroom[];
}

export async function createClassroom(name: string, code: string): Promise<Classroom> {
  await requireUser();
  const { data, error } = await supabase.rpc("create_classroom", {
    p_name: name,
    p_code: code,
  });
  if (error) throw new Error(error.message || "Não foi possível criar a turma.");
  return data as Classroom;
}

export async function joinClassroom(code: string): Promise<Classroom> {
  await requireUser();
  const { data, error } = await supabase.rpc("join_classroom", {
    p_code: code,
  });
  if (error) throw new Error(error.message || "Não foi possível entrar na turma.");
  return data as Classroom;
}
